import React from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

const SelectAllCheckbox = ({
  listSearch,
  selectedItems,
  handleSelectAll,
  authUser,
}) => {
  const location = useLocation();
  const userType = Number(authUser?.UserTypeID);

  // Block if: Not User 5 AND (Not on restricted list OR on wrong path)
  const isUser5 = userType === 5;
  const isRestrictedUser = userType === 1 || userType === 6;
  const isCorrectLocation = location.pathname === "/admin/result";

  const hasAccess = isUser5 || (isRestrictedUser && isCorrectLocation);
  // If the user shouldn't see it, return null to render nothing
  if (!hasAccess) return null;

  // Determine if every visible item is selected (works for grouped or flat lists)
  const isAllSelected =
    Array.isArray(listSearch) &&
    listSearch.length > 0 &&
    listSearch.every((item) =>
      selectedItems.some((s) => s.AssessmentID === item.AssessmentID),
    );

  return (
    <div className="school-checkbox-column">
      <input
        type="checkbox"
        className={`school-checkbox me-3 form-check-input ${isAllSelected ? "checkbox-success" : ""}`}
        checked={isAllSelected}
        onChange={handleSelectAll}
      />
    </div>
  );
};
const mapStateToProps = (state) => ({
  authUser: state.auth.user,
});
export default connect(mapStateToProps)(SelectAllCheckbox);
